import { Add } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import AuthorizationGate from 'components/authorization-gate/authorization-gate.component';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import SearchProvider from 'components/search/search.context';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ItemsDataGrid from '../items-data-grid/items-data-grid.component';
import { useItemsFilter } from '../items-landing.hooks';
import BulkEditDataGridProvider from 'components/inc-data-grid/bulk-edit-data-grid/bulk-edit-data-grid.context';

const ItemsNative = () => {
  const { t } = useTranslation();
  const search = useItemsFilter();
  const navigate = useNavigate();

  return (
    <Box mt={2}>
      <SearchProvider value={search}>
        <SearchToolbar
          buttons={
            <AuthorizationGate permission="CREATE_ITEM">
              <Button
                onClick={() => navigate('../create')}
                startIcon={<Add />}
                data-testid="Items.Button.CreateItem"
                sx={{ whiteSpace: 'nowrap' }}
                variant="text"
              >
                {t('ItemsDataGrid.buttons.create')}
              </Button>
            </AuthorizationGate>
          }
        />
        <BulkEditDataGridProvider>
          <ItemsDataGrid />
        </BulkEditDataGridProvider>
      </SearchProvider>
    </Box>
  );
};

export default ItemsNative;
